import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  API_URL,
  DEFAULT_LANGUAGE,
} from '../../../../config/constants';
import { NodeEvent } from '../../../../types/uncinc_profile/nodes';
import { dateFormatter } from '../../../../helpers';

import './style.scss';

interface NodeEventPageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<NodeEvent>;
}

const NodeEventPage: React.FC<NodeEventPageProps> = ({ entity, className }) => {
  const classes = classNames(className, 'NodeEventPage');
  const node = entity.toJS();

  const title = node.title[0].value;
  const date = node.field_date[0].value;
  const body = node.body[0]?.processed;
  const link = node.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;

  const imageStyles = node.field_media_item[0]?.styles;
  const src = [
    `${API_URL}${imageStyles?.ratio_1_1_xs || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_sm || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_md || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_xl || ''}`,
  ];

  const audiences = node.field_target_audiences;
  const labels = node.field_labels;
  const location = node.field_location[0]?.entity.name[0].value;
  const status = node.field_status[0]?.entity.name[0]?.value;
  const type = node.field_type[0].entity.name[0].value;
  const lang = node.langcode[0]?.value || DEFAULT_LANGUAGE;

  return (
    <div className={classes}>
      <div className="NodeEventPage__title">
        {title}
      </div>
      <div className="NodeEventPage__date">
        {dateFormatter(date, lang)}
      </div>
      <div className="NodeEventPage__body">
        <WysiwygField html={body} />
      </div>
      {imageStyles && (
        <Image
          src={src}
          alt={title}
        />
      )}
      {linkUrl && (
        <div className="NodeEventPage__link">
          <CoreLink href={linkUrl}>
            {linkTitle}
          </CoreLink>
        </div>
      )}
      <div className="NodeEventPage__labels">
        {labels.map((label) => (
          <div className="NodeEventPage__labels__label">
            {label.entity.name?.[0]?.value}
          </div>
        ))}
      </div>
      {status && (
        <div className="NodeEventPage__status">
          {status}
        </div>
      )}
      <div className="NodeEventPage__audiences">
        {audiences.map((audience) => (
          <div className="NodeEventPage__audiences__audience">
            {audience.entity.name[0].value}
          </div>
        ))}
      </div>
      {location && (
        <div className="NodeEventPage__location">
          {location}
        </div>
      )}
      {type && (
        <div className="NodeEventPage__type">
          {type}
        </div>
      )}
    </div>
  );
};

export default NodeEventPage;
